import { Pipe, PipeTransform } from '@angular/core';
import { Timezone } from '../../app/models/index';
import * as moment from 'moment-timezone';


@Pipe({ name: 'convertUtcTime' })
export class UTCTimeConvert implements PipeTransform {
    timezone: Timezone = (moment.tz.zone(moment.tz.guess()));
    timezoneAbbr: string;
    isDST: boolean;

    transform(value: Date, args: string[]): any {
        if (!value) return value;
        
        let mytime = value;
        let currZone = moment.tz(new Date(), moment.tz.guess());
        this.timezoneAbbr = currZone.zoneAbbr();
        this.isDST = currZone.isDST();
        let curTimezone = (moment.tz.zone(currZone._z.name));

        let datetolocal = moment.utc(mytime).local().format();


        // use format to change timezone
        let dateConverted = moment.tz(datetolocal, curTimezone.name).format('YYYY-MM-DD HH:mm:ss');

        value = dateConverted
        return value;
        // if (value.length >= 35) {
        //     return value.substring(0, 35);
        // } else {
        //     return value;
        // }

    }
}